/* Mega menu v2 — loaded only when Theme settings > Navigation > "Use new mega menu" is on */
(function () {
  var HOVER_DELAY = 90;

  function normalize(str) {
    return (str || '').toLowerCase().replace(/[^a-z0-9]+/g, '');
  }

  function MegaMenuV2(root) {
    this.root = root;
    this.tabs = Array.prototype.slice.call(root.querySelectorAll('[data-mmv2-tab]'));
    this.panels = Array.prototype.slice.call(root.querySelectorAll('[data-mmv2-panel]'));
    this.search = root.querySelector('[data-mmv2-search]');
    this.results = root.querySelector('[data-mmv2-results]');
    this.resultsTitle = root.querySelector('[data-mmv2-results-title]');
    this.empty = root.querySelector('[data-mmv2-empty]');
    this.searchLink = root.querySelector('[data-mmv2-search-link]');
    this.searchUrl = this.searchLink ? this.searchLink.getAttribute('href') : '/search';
    this.active = (this.tabs.filter(function (t) { return t.classList.contains('is-active'); })[0] || this.tabs[0] || {}).dataset;
    this.active = this.active ? this.active.mmv2Tab : null;
    this.lastTab = this.active;
    this.timer = null;
    this.lastPointer = 'mouse';
    this.rail = root.querySelector('.mmv2__rail');
    this.layout = root.querySelector('.mmv2');
    this.scrollHint = root.querySelector('[data-mmv2-scroll-hint]');

    this.buildIndex();
    this.bind();
    this.bindSizing();
  }

  // Fit the menu to the space left under the header, and show the red badge while the rail can scroll
  MegaMenuV2.prototype.bindSizing = function () {
    var self = this;
    var navItem = this.root.closest('.site-nav__item');
    var frame = null;
    var schedule = function () {
      if (frame) return;
      frame = requestAnimationFrame(function () {
        frame = null;
        self.fitHeight();
        self.updateScrollHint();
      });
    };

    if (navItem) {
      navItem.addEventListener('mouseenter', schedule);
      navItem.addEventListener('focusin', schedule);
    }
    window.addEventListener('resize', schedule);
    window.addEventListener('scroll', schedule, { passive: true });

    if (this.rail) {
      this.rail.addEventListener('scroll', function () { self.updateScrollHint(); }, { passive: true });
      if (window.ResizeObserver) new ResizeObserver(schedule).observe(this.rail);
    }

    if (this.scrollHint) {
      this.scrollHint.addEventListener('click', function (evt) {
        evt.preventDefault();
        self.rail.scrollBy({ top: Math.round(self.rail.clientHeight * 0.7), behavior: 'smooth' });
      });
    }

    schedule();
  };

  MegaMenuV2.prototype.fitHeight = function () {
    if (!this.layout) return;
    var top = this.layout.getBoundingClientRect().top;
    var available = Math.floor(window.innerHeight - Math.max(top, 0) - 16);
    this.layout.style.setProperty('--mmv2-max-h', Math.max(available, 220) + 'px');
  };

  MegaMenuV2.prototype.updateScrollHint = function () {
    if (!this.rail || !this.scrollHint) return;
    var rail = this.rail;
    // Measure without the badge so it does not keep itself visible
    var hintSpace = this.scrollHint.hidden ? 0 : this.scrollHint.offsetHeight + 12;
    var overflow = rail.scrollHeight - hintSpace - rail.clientHeight;
    var moreBelow = overflow > 4 && rail.scrollTop < overflow - 4;
    this.scrollHint.hidden = !moreBelow;
  };

  // One entry per unique model URL (brand panels only)
  MegaMenuV2.prototype.buildIndex = function () {
    var seen = {};
    this.index = [];
    this.panels.forEach(function (panel) {
      var key = panel.dataset.mmv2Panel;
      if (key === 'search') return;
      panel.querySelectorAll('[data-mmv2-model]').forEach(function (item) {
        var href = item.querySelector('a').getAttribute('href');
        var id = href + '|' + item.dataset.mmv2Q;
        if (seen[id]) return;
        seen[id] = true;
        this.index.push({ q: normalize(item.dataset.mmv2Q), el: item, brand: panel.querySelector('.mmv2__panel-title').textContent.trim() });
      }, this);
    }, this);
  };

  MegaMenuV2.prototype.bind = function () {
    var self = this;

    this.tabs.forEach(function (tab) {
      tab.addEventListener('pointerdown', function (evt) { self.lastPointer = evt.pointerType; });

      tab.addEventListener('mouseenter', function () {
        clearTimeout(self.timer);
        self.timer = setTimeout(function () { self.activate(tab.dataset.mmv2Tab); }, HOVER_DELAY);
      });
      tab.addEventListener('mouseleave', function () { clearTimeout(self.timer); });
      tab.addEventListener('focus', function () { self.activate(tab.dataset.mmv2Tab); });

      tab.addEventListener('click', function (evt) {
        // Touch: first tap previews the brand, second tap follows the link
        var isLink = tab.tagName === 'A';
        if (!isLink || (self.lastPointer === 'touch' && self.active !== tab.dataset.mmv2Tab)) {
          evt.preventDefault();
          self.activate(tab.dataset.mmv2Tab);
        }
      });
    });

    // Keep taps inside the menu from bubbling to the theme's "click outside closes menu" handler
    ['touchend', 'click'].forEach(function (type) {
      self.root.addEventListener(type, function (evt) {
        if (evt.target.closest('a[href]:not([data-mmv2-tab])')) return;
        evt.stopPropagation();
      });
    });

    if (this.search) {
      this.search.addEventListener('input', function () { self.filter(self.search.value); });
      this.search.addEventListener('keydown', function (evt) {
        if (evt.key === 'Escape') {
          self.search.value = '';
          self.filter('');
        } else if (evt.key === 'Enter') {
          evt.preventDefault();
          var first = self.results.querySelector('a');
          window.location.href = first ? first.getAttribute('href') : self.buildSearchUrl(self.search.value);
        }
      });
    }
  };

  MegaMenuV2.prototype.activate = function (key) {
    if (!key) return;
    if (this.search && this.search.value && key !== 'search') {
      this.search.value = '';
      this.clearResults();
    }
    if (key !== 'search') this.lastTab = key;
    this.active = key;

    this.tabs.forEach(function (tab) {
      var on = tab.dataset.mmv2Tab === key;
      tab.classList.toggle('is-active', on);
      if (on) { tab.setAttribute('aria-current', 'true'); } else { tab.removeAttribute('aria-current'); }
    });
    this.panels.forEach(function (panel) {
      var on = panel.dataset.mmv2Panel === key;
      panel.hidden = !on;
      panel.classList.toggle('is-active', on);
    });
  };

  MegaMenuV2.prototype.clearResults = function () {
    while (this.results.firstChild) this.results.removeChild(this.results.firstChild);
  };

  MegaMenuV2.prototype.buildSearchUrl = function (term) {
    var sep = this.searchUrl.indexOf('?') > -1 ? '&' : '?';
    return this.searchUrl + sep + 'q=' + encodeURIComponent(term.trim());
  };

  MegaMenuV2.prototype.filter = function (value) {
    var term = value.trim().toLowerCase();
    this.clearResults();

    if (!term) {
      this.activate(this.lastTab);
      return;
    }

    // Match each typed word ignoring spaces/punctuation, so "rf1400" finds "RF-1400"
    var words = term.split(/\s+/).map(normalize).filter(Boolean);
    var matches = this.index.filter(function (entry) {
      return words.every(function (w) { return entry.q.indexOf(w) > -1; });
    });

    var frag = document.createDocumentFragment();
    matches.forEach(function (entry) {
      var clone = entry.el.cloneNode(true);
      clone.hidden = false;
      var body = clone.querySelector('.mmv2__model-body');
      if (body && !body.querySelector('.mmv2__model-brand')) {
        var brand = document.createElement('span');
        brand.className = 'mmv2__model-brand';
        brand.textContent = entry.brand;
        body.insertBefore(brand, body.firstChild);
      }
      frag.appendChild(clone);
    });
    this.results.appendChild(frag);

    this.resultsTitle.textContent = matches.length + ' ' + (matches.length === 1 ? 'match' : 'matches') + ' for “' + value.trim() + '”';
    this.empty.hidden = matches.length > 0;
    if (this.searchLink) this.searchLink.setAttribute('href', this.buildSearchUrl(value));

    var lastTab = this.lastTab;
    this.activate('search');
    this.lastTab = lastTab;
    this.tabs.forEach(function (tab) { tab.classList.remove('is-active'); tab.removeAttribute('aria-current'); });
  };

  function init() {
    document.querySelectorAll('[data-mega-v2]').forEach(function (el) {
      if (el.__megaV2) return;
      el.__megaV2 = new MegaMenuV2(el);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', init);
})();
